import { PricingModules } from '../../../../context/contexts/PricingModuleContext';
import {
    ACCOUNT_MATCHING_FIELDS,
    COMPANY_INFO_FIELDS,
    DESKTOP_NOTIFICATION_FIELDS,
    ENROLLMENT_SETTINGS_FIELDS,
    OTP_NOTIFICATION_FIELDS,
    ADVANCED_CONFIG_FIELDS,
    MAINTENANCE_FIELDS,
    ADMIN_SECURITY_ROLES_FIELDS
} from '../../common/fields';
import { TOOLTIP_PROP_OPTIONS } from '../../../common/LockedFeatures';
import { DisabledDisplayOptions, DisplayConfig, RequiredModuleState } from './types';

// TODO: port all the fields from SYSTEM_MODE_HIDDEN_VIEWS to this config
export const HIDDEN_FIELDS_CONFIG: { [fieldId: string]: DisplayConfig } = {
    [COMPANY_INFO_FIELDS.WINDOWS_LOGON_TOKEN.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.BASE_PLATFORM]: {
                requiredState: RequiredModuleState.ON_PREM_ENABLED,
                disabledDisplayOption: DisabledDisplayOptions.HIDDEN
            }
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED,
        moduleMatchLogic: 'ALL'
    },
    [COMPANY_INFO_FIELDS.AUTO_DENY_MFA_WINDOW_SIZE.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.TOOLTIP,
        tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_ICON.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_BACKGROUND.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.DISPLAY_ICON_ENABLED.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_HEIGHT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_WIDTH.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.WINDOW_POSITION.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_TITLE.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.MFA_NOTIFICATION_TEXT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.TIMEOUT_NOTIFICATION_TEXT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [DESKTOP_NOTIFICATION_FIELDS.NOTIFICATIONS_TIMEOUT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_ICON.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_BACKGROUND1.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_BACKGROUND2.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_DISPLAY_ICON_ENABLED.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_HEIGHT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_WIDTH.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_NOTIFICATION_TEXT.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [OTP_NOTIFICATION_FIELDS.OTP_ON_AUTO_PAIRED_DEVICES.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ACCOUNT_MATCHING_FIELDS.IS_TOKEN_SHARING_ENABLED.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ENROLLMENT_SETTINGS_FIELDS.MAX_TOKENS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ENROLLMENT_SETTINGS_FIELDS.UNPAIRED_USER_POLICY.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ENROLLMENT_SETTINGS_FIELDS.ENROLLMENT_CONFIRMATION.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [COMPANY_INFO_FIELDS.COMPANY_SUPPORT_EMAIL.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [COMPANY_INFO_FIELDS.SNMP_ACCOUNT.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [COMPANY_INFO_FIELDS.CLEAN_AUTH_LOGS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [COMPANY_INFO_FIELDS.MAX_AUTH_AGG_THRESHOLD.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [COMPANY_INFO_FIELDS.AUTO_DENY_MFA_THRESHOLD.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADVANCED_CONFIG_FIELDS.CONFIG_ALL_NODES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADVANCED_CONFIG_FIELDS.CONFIG_NODE.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.LOG_LEVEL.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.PUSH_SERVICES_LOG_LEVEL.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.OFFLINE_MODE.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.SEND_DIAGNOSTICS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.SEND_DIAGNOSTICS_ANON.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.AUTO_AD_ADAPTER_UPGRADE.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.ADD_PASSWORD_TO_LOGS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.CLIENT_LOG_PASSWORD.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.ALLOW_SEND_LOGS_TO_SILVERHUB.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [MAINTENANCE_FIELDS.EXPIRE_SEND_LOGS_TO_SILVERHUB.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.USERS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.SYSTEM_STATUS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.PRIVILEGED_ACCOUNTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.INVENTORY_AD.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.POLICIES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.SERVICE_ACCOUNTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.ACCESS_ANALYSIS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.INSIGHTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.RISK.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.INSIGHTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.LOGS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.AUTHORIZE.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    },
    [ADMIN_SECURITY_ROLES_FIELDS.TEST_MFA_TOKENS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        disabledDisplayOption: DisabledDisplayOptions.HIDDEN
    }
};
